@if (isNewDesign()) {
  <div
    class="w-full h-full flex flex-col gap-lg p-xl rounded-xl bg-white border border-neutral-200"
    [style.width]="width()">
    <div class="flex justify-between items-center gap-sm">
      @if (overline()) {
        <div class="flex min-w-0 items-center gap-x-sm">
          <span
            data-stat-dot
            class="size-[0.625rem] shrink-0 rounded-full"
            [class]="dotClass()"></span>
          <p
            class="truncate text-sm font-normal text-neutral-600"
            [title]="overline()">
            {{ overline() }}
          </p>
        </div>
      }

      <div class="flex items-center gap-sm ms-auto">
        @if (tag()) {
          <p
            class="tag text-success-700 text-sm bg-success-50 rounded-3xl py-x-sm px-sm">
            <span class="text-base">&#8593;</span> {{ tag() }} %
          </p>
        }

        @if (actionIconTemplate()) {
          <button (click)="actionIconClick.emit()">
            <ng-container [ngTemplateOutlet]="actionIconTemplate()" />
          </button>
        }
      </div>
    </div>

    <div class="flex flex-col gap-x-sm">
      <!----------------------- trim label when needed  --------------------------->
      @if (isLabelTrim()) {
        <p
          data-stat-value
          class="text-3xl font-bold"
          [class]="valueClass()"
          [trimLength]="trimLabelLength()"
          libTrimTooltip
          placement="top"
          [toolTipClass]="'bg-white p-md rounded-lg shadow-lg tooltip-width tooltip-arrow tooltip-arrow-top'"
          [fullText]="displayedLabel()"></p>
      } @else {
        <p
          data-stat-value
          class="text-3xl font-bold leading-tight tracking-tight"
          [class]="valueClass()"
          [attr.title]="valueTitle()">
          {{ displayedValue() }}
        </p>
      }

      @if (description()) {
        <p class="text-xs font-normal text-neutral-500">
          {{ description() }}
        </p>
      }

      @if (BadgeLabel()) {
        <lib-badge
          [label]="BadgeLabel()"
          [badgeClass]="
            'px-sm border-none text-sm font-medium ' + badgeClass()
          " />
      }
    </div>
  </div>
} @else {
  <div
    class="w-full flex justify-between items-center gap-2xl p-2xl rounded-lg bg-white shadow-sm"
    [style.width]="width()">
    <div class="flex items-center">
      @if (iconSvgName()) {
        <span class="flex p-md bg-primary-50 rounded-md">
          <lib-stat-icons [iconName]="iconSvgName()" />
        </span>
      }

      <div class="flex flex-col gap-x-sm ms-2xl">
        @if (overline()) {
          <p class="text-xs font-medium text-neutral-500">
            {{ overline() }}
          </p>
        }

        <!----------------------- trim label when needed  --------------------------->
        @if (isLabelTrim()) {
          <p
            class="text-2xl font-semibold text-neutral-900"
            [trimLength]="trimLabelLength()"
            libTrimTooltip
            placement="top"
            [toolTipClass]="'bg-white p-md rounded-lg shadow-lg tooltip-width tooltip-arrow tooltip-arrow-top'"
            [fullText]="displayedLabel()"></p>
        } @else {
          <p class="text-2xl font-semibold text-neutral-900">
            {{ label() }}
          </p>
        }

        @if (description()) {
          <p class="text-sm font-medium text-neutral-500">
            {{ description() }}
          </p>
        }

        @if (BadgeLabel()) {
          <lib-badge
            [label]="BadgeLabel()"
            [badgeClass]="
              'px-sm border-none text-sm font-medium ' + badgeClass()
            " />
        }
      </div>
    </div>

    <div class="flex items-center gap-sm">
      @if (tag()) {
        <p
          class="tag text-success-700 text-sm bg-success-50 rounded-3xl py-x-sm px-sm">
          <span class="text-base">&#8593;</span> {{ tag() }} %
        </p>
      }

      @if (actionIconTemplate()) {
        <button (click)="actionIconClick.emit()">
          <ng-container [ngTemplateOutlet]="actionIconTemplate()" />
        </button>
      }
    </div>
  </div>
}
